import values from './values'

export const LIFE_PROTECT_PLUS_GROUP_CODES = [
  ...Object.values(values.LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.COMBO_CI_LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.COMBO_HEALTH_ESSENTIAL_LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.HEALTH_ULTRA_LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.HEALTH_EXTRA_LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.ROKE_RAI_SO_SHIELD_LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.KOOMVER_COMPENSATE_LIFEPROTECT_PLUS_CODE),
  ...Object.values(values.KOOMVER_ROKE_RAI_LIFEPROTECT_PLUS_CODE),
]
